import {QueryableProperty} from './queryableProperty';
import {QueryFilter} from './queryCreator';

export abstract class PropertyFilter {
  property: QueryableProperty;
  active: boolean = false;

  abstract solve(object: any): boolean;
  abstract toQueryFilter(): QueryFilter;
}

